/**
 * Сборка для подключения перед public/.../js/script.js (без ES modules в странице).
 * rollup-unified-accordion.config.js → app/assets/builds/unified_accordion.js
 */
import * as U from "./components/unifiedAccordion.js";

window.UnifiedAccordion = {
  scrollAccordionHeaderIntoView: U.scrollAccordionHeaderIntoView,
  initMiddleHighSchoolAccordions: U.initMiddleHighSchoolAccordions,
  initKindergartenLearningAccordion: U.initKindergartenLearningAccordion,
  initLandingPageAccordions: U.initLandingPageAccordions
};
